import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./style.css";
import { StrictModeDroppable } from "./StrictModeDroppable";
import { MdDoNotDisturbOn } from "react-icons/md";
import { MdOutlineCircle } from "react-icons/md";
import { BsTrash3Fill } from "react-icons/bs";
import { useEffect } from "react";
import {
  LeadingActions,
  SwipeableList,
  SwipeableListItem,
  SwipeAction,
  TrailingActions,
  Type as ListType,
} from "react-swipeable-list";
import "react-swipeable-list/dist/styles.css";
import useAppAccessor from "../../../../hooks/useappAccessor";
import {
  Facebooklink,
  Messanger,
  Instagramlink,
  Link,
  Linkedinlink,
  Pinterestlink,
  Twitterlink,
  Whatsapplink,
  NoPhoto,
  Star,
  Star_Inactive,
  View_Visible,
  View_NotVisible,
  Grabber_White,
  Grabber,
  View_VisibleMA,
  View_VisibleZyia,
  View_VisibleYoli,
  View_NotVisibleMA,
  View_NotVisibleZyia,
  View_NotVisibleYoli,
  GrabberMA,
  GrabberZyia,
  GrabberYoli,
  GrabberDefault,
  GrabberTranont,
  View_NotVisibleTranont,
} from "../../../../assets/icons";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { setInteractionData } from "../../interaction.actions";
import _ from "lodash";
import { saveInteractionAPI } from "../../../../services/record.service";
import { Chance } from "chance";
import { callEvent } from "../../../../services/main.service";
import { getBrandColor } from "../../../../utils/brand.util";

const leadingActions = () => (
  <LeadingActions>
    <SwipeAction onClick={() => console.info("swipe action triggered")}>
      Action name
    </SwipeAction>
  </LeadingActions>
);

const decimalComponent = (number: any) => {
  
  if (number == undefined) return;
  if (number.includes("-")) {
    const numb1: any = number.toString().split("-")[0];
    const numb2: any = number.toString().split("-")[1];
    const [integerPart, decimalPart] = numb1.toString().split(".");
    const [integerPart_2, decimalPart_2] = numb2.toString().split(".");

    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart ? `${integerPart}.` : `${integerPart}`}
          { decimalPart ? <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
           >{`${decimalPart}`}</span> : <span> </span>
          }
        </div>
        -
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15, marginLeft: 5 }}
        >
          {decimalPart_2 ? `${integerPart_2}.` : `${integerPart_2}`}
          { decimalPart_2 ? <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_2}`}</span> : <span> </span>
          } 
        </div>
      </div>
    );
  } else if (number.includes(",")) {
    const [integerPart_3, decimalPart_3] = number.toString().split(",");
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3
            ? `${integerPart_3},`
            : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  } else {
    var [integerPart_3, decimalPart_3] = number.toString().split(".");
    if (decimalPart_3.includes(" ")) {
      decimalPart_3 = decimalPart_3.split(" ")[0];
    }
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3
            ? `${integerPart_3}.`
            : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  }
};

const decodeHtmlEntities = (html: string | undefined): string => {
  if (!html) return '';
  try {
    // 创建textarea元素来利用浏览器的HTML实体解码功能
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    
    // 如果是简单的HTML实体（如&reg;, &copy;等），textarea.value会处理
    // 但对于更复杂的HTML内容，可能需要额外的清理
    const decodedText = textarea.value;
    
    // 如果解码后的文本为空但原始文本不为空，则返回原始文本
    // 这可能发生在某些浏览器环境中
    return decodedText || html;
  } catch (error) {
    // 如果发生错误，返回原始文本
    console.error('Error decoding HTML entities:', error);
    return html;
  }
};

const finalSpaceCharacters = [
  {
    id: "gary",
    name: "Gary Goodspeed",
    thumb: "/images/gary.png",
  },
  {
    id: "cato",
    name: "Little Cato",
    thumb: "/images/cato.png",
  },
  {
    id: "kvn",
    name: "KVN",
    thumb: "/images/kvn.png",
  },
  {
    id: "mooncake",
    name: "Mooncake",
    thumb: "/images/mooncake.png",
  },
  {
    id: "quinn",
    name: "Quinn Ergon",
    thumb: "/images/quinn.png",
  },
  {
    id: "Shmquinn",
    name: "Quinn Ergon",
    thumb: "/images/quinn.png",
  },
];

const chance = new Chance();

function DraggableList(props: any) {
  const dispatch = useAppDispatch();
  const { getInteractions, getLiveMainData, getUserData } = useAppAccessor();
  const { interactionData } = getInteractions();
  const { language, client } = getUserData();

  const [interactionsAllData, setInteractionsAllData] = useState<any>([]);
  const [selectedInteractionIds, setSelectedInteractionIds] = useState<any>([]);
  const [txtContainerWidth, setTxtContainerWidth] = useState(0);
  const [txtContainerWidthInit, setTxtContainerWidthInit] = useState(0);
  const [isShowCheck, setIsShowCheck] = useState(false);
  const { configurationData,createStreamData, joinWithAttendeeData, hostTime} = getLiveMainData();

  const [characters, updateCharacters] = useState(finalSpaceCharacters);
  const [dragDivHeight, setDragDivHeight] = useState<any>(0);
  function handleOnDragEnd(result: any) {
    if (!result.destination) return;

    const items = Array.from(interactionsAllData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setInteractionsAllData(items);
  }

  const trailingActions = (item: any) => (
    <TrailingActions>
      <SwipeAction
        destructive={true}
        onClick={() => {
          handleRemoveItemFromArray(item);
        }}
      >
        <div className="flex items-center bg-[#A40808]  justify-center pl-5 pr-5">
          <BsTrash3Fill color={"#ffffff"} size={26}></BsTrash3Fill>
        </div>
      </SwipeAction>
    </TrailingActions>
  );

  useEffect(() => {
   // console.log(
      // "value===>",
    //   window.document.getElementById("dragContainer")?.offsetHeight
    // );
    let tempvalue: any = 0;
    tempvalue = window.document.getElementById("dragContainer")?.offsetHeight;
    setDragDivHeight(tempvalue - 100);
    setTimeout(() => {
      setIsShowCheck(true);
      let tempWidth: any = 0;
      tempWidth = document.getElementById(
        `dragTextRowContainer_${0}`
      )?.offsetWidth;

      setTxtContainerWidthInit(tempWidth);
    }, 200);
  }, []);

  useEffect(() => {
    if (interactionData.length > 0) {
      setInteractionsAllData(interactionData);
    }
  }, [interactionData]);

  const getIconManualInteraction = (type: any) => {
    switch (type) {
      case "Facebook":
        return Facebooklink;
      case "Instagram":
        return Instagramlink;
      case "LinkedIn":
        return Linkedinlink;
      case "Twitter":
        return Twitterlink;
      case "Pinterest":
        return Pinterestlink;
      case "Messenger":
        return Messanger;
      case "WhatsApp":
        return Whatsapplink;
      default:
        return NoPhoto;
    }
  };

  const getInteractionTypeCheck = (type: any) => {
    switch (type) {
      case "social":
        return false;
      case "link":
        return false;
      case "media":
        return true;
      default:
        return true;
    }
  };

  const checkBrandVisible = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return View_VisibleMA;
      }
      case "zyiaactive": {
        return View_VisibleZyia;
      }
      case "beyondslim": {
        return View_VisibleZyia;
      }
      case "Yoli": {
        return View_VisibleYoli;
      }
      case "Verb": {
        return View_VisibleZyia;
      }
      case "Hussle": {
        return View_VisibleZyia;
      }
      case "tranont": {
        return View_VisibleZyia;
      }

      default:
        return View_Visible;
    }
  };

  const checkBrandUnVisible = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return View_NotVisibleMA;
      }
      case "zyiaactive": {
        return View_NotVisibleZyia;
      }
      case "beyondslim": {
        return View_NotVisibleZyia;
      }
      case "Yoli": {
        return View_NotVisibleYoli;
      }
      case "Verb": {
        return View_NotVisibleZyia;
      }
      case "Hussle": {
        return View_NotVisibleZyia;
      }
      case "tranont": {
        return View_NotVisibleTranont;
      }

      default:
        return View_NotVisible;
    }
  };


  const checkDeleteButtonColor = (client: any) => {
    switch (client) {
      case "tranont": {
        return "#999999";
      }
      default: {
        return "#A40808";
      }
    }
  };

  const checkGrabber = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return GrabberMA;
      }
      case "zyiaactive": {
        return GrabberZyia;
      }
      case "beyondslim": {
        return GrabberZyia;
      }
      case "Yoli": {
        return GrabberYoli;
      }
      case "Verb": {
        return GrabberDefault;
      }
      case "Hussle": {
        return GrabberDefault;
      }
      case "tranont": {
        return GrabberTranont;
      }

      default:
        return Grabber;
    }
  };

  const getLinkValidation = (type: any, url: any) => {
    if (type == "link") {
      if (url == "") {
        return false;
      } else {
        return true;
      }
    }
  };

  // useEffect(()=>{
  //   dispatch(setInteractionData(interactionsAllData))
  // },[interactionsAllData])

  useEffect(() => {
    if (props.isCLickedDone) {
      dispatch(setInteractionData(interactionsAllData));
    }
  }, [props.isCLickedDone]);

  const handleRemoveItemFromArray = (item: any) => {
    //  // console.log("onclicked===","Yes")
    //   let temArray:any = _.cloneDeep(interactionsAllData)
    //   setInteractionsAllData([]);
    //   temArray = _.remove(interactionsAllData, (currentObject:any) =>{
    //     return currentObject.interaction_id === item.interaction_id;
    // });
    // setInteractionsAllData(temArray)

    setInteractionsAllData(
      interactionsAllData.filter(function (currentOBj: any) {
        return currentOBj.interaction_id !== item.interaction_id;
      })
    );

    saveInteractionAPI(
      configurationData?.stream_id,
      interactionsAllData.filter(
        (data: any) => data?.interaction_id !== item?.interaction_id
      )
    );
  };

  const hanldeShoudlShowProp = (item: any, flag: any) => {
    // _.find(interactionsAllData, { interaction_id: item.interaction_id }).attributes.shouldShow = flag
    let temArray: any = _.cloneDeep(interactionsAllData);
    setInteractionsAllData([]);
    temArray.forEach((element: any, index: any) => {
      if (element.interaction_id === item.interaction_id) {
        temArray[index].attributes.shouldShow = flag;
        var resp = createStreamData;
        var data = temArray[index];
       // console.log(resp , 'resp=====')
        if (resp.hasOwnProperty('metadata') && resp['metadata'].hasOwnProperty('attendees')) {
          callEvent([{"event_data":{
            "attendee_email":resp["email"],
            "attendee_first":resp["given_name"],
            "attendee_id":resp["attendee_id"],
            "attendee_role":"attendee",
            "attendee_last":resp["family_name"]+" (host)",
            "client_id":resp['metadata']['attendees'].filter((p: { role: string; })=> p.role == 'host')[0].attendee_id.split('|')[0],
            "stream_id":joinWithAttendeeData['stream_id'],
            "stream_instance_id":resp["stream_instance_id"],
            "user_id":resp['metadata']['attendees'].filter((p: { role: string; }) => p.role == 'host')[0].attendee_id.split('|')[1],
            "interaction_id": data.interaction_id,
            "interaction_type": data.attributes.type,
            "interaction_label": data.attributes.label,
            "interaction_action": data.attributes.action,
            "interaction_imageUrl": data.style.thumbnail_url,
            "elapsed_seconds":hostTime,
            "date":new Date().toUTCString()},
            "event_type":"interaction_created"}]);
        }
      }
    });
    setInteractionsAllData(temArray);

    saveInteractionAPI(
      configurationData?.stream_id,
      temArray
      // temArray.filter((data: any) => data.attributes.shouldShow === true)
    );
  };

  const handleToggleElement = (element: any, ind: any) => {
    // Check if the element is already in the array
    const isElementInArray = selectedInteractionIds.includes(element);

    if (isElementInArray) {
      // If it's in the array, remove it
      const newArray = selectedInteractionIds.filter(
        (item: any) => item !== element
      );
      setSelectedInteractionIds(newArray);
    } else {
      // If it's not in the array, add it
      setSelectedInteractionIds([...selectedInteractionIds, element]);
    }

    setTimeout(() => {
      if (txtContainerWidth == 0) {
        let tempWidth: any = 0;
        tempWidth = document.getElementById(
          `dragTextRowContainer_${ind}`
        )?.offsetWidth;
        setTxtContainerWidth(tempWidth);
      }
    }, 10);
  };

  const checkTitle = (title : string) => {

    const formattedStringFirst = title.replace(/#\d+\b\.?\s?/g, '');
    const formattedString = formattedStringFirst.replace(/[^\x20-\x7E®]/g, '');
    
    if(formattedString.includes('Lumire')) {
        return formattedString.replace('Lumire', "Lumière")
    }

      return formattedString.trim(); 
  } 

  return (
    <div className="App">
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <StrictModeDroppable droppableId="shshs">
          {(provided) => (
            <div
              className={`overflow-y-auto  containerDragSheet`}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {interactionsAllData.map((data: any, index: any) => {
                return (
                  <Draggable
                    key={data.interaction_id}
                    draggableId={data.interaction_id}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`${
                          data?.featured
                            ? `bg-[${getBrandColor(client)}]`
                            : "bg-white"
                        }`}
                      >
                        {/* <div className="characters-thumb">
                            <img src={thumb} alt={`${name} Thumb`} />
                          </div>
                          <p>
                            { name }
                          </p> */}
                        {/* <SwipeableList type={ListType.IOS}>
  <SwipeableListItem trailingActions={trailingActions(data)}>                       */}
                        <div className="flex-col w-full">
                          <div className="flex w-full ">
                            <div
                              style={{
                                backgroundColor: data?.featured
                                  ? getBrandColor(client)
                                  : "white",
                              }}
                              className={`flex h-full ${
                                selectedInteractionIds.includes(
                                  data.interaction_id
                                )
                                  ? "w-4/5"
                                  : "w-full"
                              } 
                               items-center  ${
                                 data?.attributes?.shouldShow
                                   ? "opacity-100"
                                   : "opacity-100"
                               }`}
                            >
                              <div
                                className="flex items-center ml-2 mt-4"
                                style={{
                                  width: selectedInteractionIds.includes(
                                    data.interaction_id
                                  )
                                    ? "20%"
                                    : "15%",
                                }}
                              >
                                <div className="h-[20px] w-[20px] min-h-[20px] min-w-[20px]">
                                  {selectedInteractionIds.includes(
                                    data.interaction_id
                                  ) && (
                                    <MdDoNotDisturbOn
                                      color="#E64545"
                                      size={20}
                                      cursor="pointer"
                                      onClick={() => {
                                        handleToggleElement(
                                          data.interaction_id,
                                          index
                                        );
                                      }}
                                    />
                                  )}
                                  {!selectedInteractionIds.includes(
                                    data.interaction_id
                                  ) && (
                                    <div
                                      className={`rounded-full border ${
                                        !data?.featured
                                          ? "border-[#414141]"
                                          : "border-white"
                                      }`}
                                      style={{
                                        height: 18,
                                        width: 18,
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        handleToggleElement(
                                          data.interaction_id,
                                          index
                                        );
                                      }}
                                    />
                                  )}
                                </div>
                                <img
                                  src={data?.featured ? Grabber_White : checkGrabber(client)}
                                  alt="Icon"
                                  className=" ml-2 h-[25px] w-[25px]"
                                  {...provided.dragHandleProps}
                                />
                              </div>
                              <div
                                className="items-start "
                                style={{
                                  width: selectedInteractionIds.includes(
                                    data.interaction_id
                                  )
                                    ? "80%"
                                    : "85%",
                                }}
                                id={`dragTextRowContainer_${index}`}
                              >
                                <div
                                  style={{
                                    backgroundColor: data?.featured
                                      ? getBrandColor(client)
                                      : "white",
                                  }}
                                  className={`${
                                    data?.attributes?.shouldShow
                                      ? "opacity-100"
                                      : "opacity-100"
                                  }`}
                                >
                                  <div
                                    id="interactonRowDragg"
                                    style={{
                                      width: selectedInteractionIds.includes(
                                        data.interaction_id
                                      )
                                        ? txtContainerWidth
                                        : txtContainerWidthInit,
                                      pointerEvents: "none",
                                      backgroundColor: data?.featured
                                        ? getBrandColor(client)
                                        : "white",
                                    }}
                                    className={`flex items-center  cursor-pointer relative pl-2`}
                                  >
                                    {isShowCheck && (
                                      <div className="flex flex-row absolute right-2 top-2">
                                        {/* <input
                                className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-[#4C4B4B] before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-hussle_light_blue_1 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-hussle_light_blue_1 checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-hussle_light_blue_1 dark:checked:after:bg-hussle_light_blue_1 dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(90,160,251,1)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault02"
                                style={{pointerEvents:'all'}}
                                checked={data?.attributes?.shouldShow}
                                onChange={()=>{hanldeShoudlShowProp(data,!data?.attributes?.shouldShow)}}/> */}
                                        {data?.featured && (
                                          <div className="flex   border border-white rounded pl-1.5 pr-1.5 pt-1 pb-1">
                                            <span
                                              className={`text-sm ${
                                                data?.featured
                                                  ? "text-white"
                                                  : "text-[#936FFF]"
                                              }  mb-0 mr-2`}
                                            >
                                              {language["featured"]}
                                            </span>
                                            {/* {data?.featured&&<BsStarFill size={15} color={(data?.featured)?'#ffffff':'#936FFF'}></BsStarFill>} */}
                                            {data?.featured && (
                                              <img
                                                src={Star}
                                                style={{
                                                  height: "21px !important",
                                                  width: "21px !important",
                                                  opacity: "100 !important",
                                                }}
                                              ></img>
                                            )}
                                          </div>
                                        )}

                                        {!data?.featured && (
                                          <div className="flex opacity-20 border border-black rounded pl-1.5 pr-1.5 pt-1 pb-1">
                                            <span
                                              className={`text-sm ${
                                                data?.featured
                                                  ? "text-white"
                                                  : "text-black"
                                              }  mb-0 mr-2`}
                                            >
                                              {language["featured"]}
                                            </span>
                                            {/* {data?.featured&&<BsStarFill size={15} color={(data?.featured)?'#ffffff':'#936FFF'}></BsStarFill>} */}
                                            {!data?.featured && (
                                              <img
                                                src={Star_Inactive}
                                                style={{
                                                  height: "21px !important",
                                                  width: "21px !important",
                                                  opacity: "100 !important",
                                                }}
                                              ></img>
                                            )}
                                          </div>
                                        )}

                                        {data?.attributes?.shouldShow && (
                                          <img
                                            src={checkBrandVisible(client)}
                                            height={24}
                                            width={24}
                                            className="cursor-pointer ml-2"
                                            style={{ pointerEvents: "all" }}
                                            onClick={() => {
                                              hanldeShoudlShowProp(data, false);
                                            }}
                                          ></img>
                                        )}

                                        {!data?.attributes?.shouldShow && (
                                            <img
                                              src={checkBrandUnVisible(client)}
                                              height={24}
                                              width={24}
                                              className="cursor-pointer ml-2"
                                              style={{ pointerEvents: "all" }}
                                              onClick={() => {
                                                hanldeShoudlShowProp(data, true);
                                              }}
                                            ></img>
                                        )}
                                      </div>
                                    )}

                                    <div
                                      className="flex items-center justify-center mb-3 mt-2"
                                      style={{
                                        marginTop: data?.featured ? 25 : 25,
                                      }}
                                    >
                                      <div
                                        className={` flex  items-center justify-center ${
                                          getInteractionTypeCheck(
                                            data?.interaction_type
                                          )
                                            ? "bg-white"
                                            : ""
                                        } h-[75px] min-h-[75px] min-w-[75px] w-[75px] ${
                                          getInteractionTypeCheck(
                                            data?.interaction_type
                                          )
                                            ? "rounded-lg border border-[#979797]"
                                            : ""
                                        } mt-2 relative`}
                                      >
                                        {/* <img src={'https://www.kasandbox.org/programming-images/avatars/marcimus-orange.png'} alt="Icon" height={68} width={68}  /> */}
                                        {data?.interaction_type == "link" ? (
                                          <img
                                            src={
                                              getLinkValidation(
                                                data?.interaction_type,
                                                data?.style?.thumbnail_url
                                              )
                                                ? data?.style?.thumbnail_url
                                                : NoPhoto
                                            }
                                            alt="Icon"
                                            style={
                                              getLinkValidation(
                                                data?.interaction_type,
                                                data?.style?.thumbnail_url
                                              )
                                                ? { height: 68, width: 68 }
                                                : { height: 28, width: 28 }
                                            }
                                          />
                                        ) : (
                                          <img
                                            src={
                                              getInteractionTypeCheck(
                                                data?.interaction_type
                                              )
                                                ? data?.style?.thumbnail_url
                                                : getIconManualInteraction(
                                                    data?.interaction_icon
                                                  )
                                            }
                                            alt="Icon"
                                            style={{ height: 68, width: 68 }}
                                          />
                                        )}
                                        {/* {(data?.interaction_type ==
                                          "shop_com" ||
                                          data?.real_type == "shop_com") && (
                                          <div className=" flex  w-full rounded-b-lg bg-[#B59EFF] text-white justify-center absolute bottom-0">
                                            Buy
                                          </div>
                                        )} */}
                                      </div>
                                      <div
                                        className="ml-2 flex-col flex items-start pt-6"
                                        style={{
                                          width:
                                            selectedInteractionIds.includes(
                                              data.interaction_id
                                            )
                                              ? txtContainerWidth
                                              : txtContainerWidthInit,
                                        }}
                                      >
                                        {data?.attributes?.labelVisible && (
                                          <span
                                            className={`${
                                              data?.featured
                                                ? "text-white"
                                                : "text-[#595959]"
                                            } font-medium mb-0`}
                                            style={{
                                              fontSize: '0.9rem',
                            lineHeight: '1.5rem',
                                              width:
                                                selectedInteractionIds.includes(
                                                  data.interaction_id
                                                )
                                                  ? txtContainerWidth - 100
                                                  : txtContainerWidthInit - 100,
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textAlign: "initial",
                                            }}
                                            title={decodeHtmlEntities(data?.attributes?.label)}
                                          >
                                            {decodeHtmlEntities(data?.attributes?.label)}
                                          </span>
                                        )}
                                        {/* {data?.interaction_type=='shop_com'&&<span className={`text-lg	 text-[#595959] font-medium border border-[#979797] rounded-md pl-1 pr-1   ${(data?.featured)?'bg-white':''}`} >{data?.attributes?.price}</span>} */}
                                        {(data?.interaction_type ==
                                          "shop_com" ||
                                          data?.real_type == "shop_com") && (
                                          <span
                                            className={`text-lg	 ${
                                              data?.featured
                                                ? "text-[#595959]"
                                                : "text-[#595959]"
                                            } font-medium border border-[#979797] rounded-md pl-1 pr-1   ${
                                              data?.featured ? "bg-white" : ""
                                            }`}
                                          >
                                            {decimalComponent(
                                              data?.attributes?.price
                                            )}
                                          </span>
                                        )}
                                        {/* {data?.interaction_type != "shop_com" &&
                                          data?.real_type != "shop_com" && (
                                            <span
                                              className={`text-base ${
                                                data?.featured
                                                  ? "text-white"
                                                  : "text-[#595959]"
                                              } font-medium mb-0`}
                                              style={{
                                                width:
                                                  selectedInteractionIds.includes(
                                                    data.interaction_id
                                                  )
                                                    ? txtContainerWidth - 100
                                                    : txtContainerWidthInit -
                                                      100,
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textAlign: "initial",
                                              }}
                                            >
                                              {data?.attributes?.action}
                                            </span>
                                          )} */}
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="border-t-2 ml-2 mr-2 "></div> */}
                                </div>
                              </div>
                            </div>
                            {/* <div className='border-b border-[#979797] mt-3'></div> */}
                            {selectedInteractionIds.includes(
                              data.interaction_id
                            ) && (
                              <div
                                className="w-1/5 flex justify-center items-center"
                                style={{
                                  backgroundColor: checkDeleteButtonColor(client),
                                }}
                                onClick={() => {
                                  handleRemoveItemFromArray(data);
                                }}
                              >
                                <BsTrash3Fill
                                  color={"#ffffff"}
                                  size={26}
                                  cursor="pointer"
                                ></BsTrash3Fill>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* </SwipeableListItem>
</SwipeableList> */}
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </StrictModeDroppable>
      </DragDropContext>
    </div>
  );
}

export default DraggableList;
